<template>
    <div class="body">
    
    <vue-particles
        color="#999999"
        :particleOpacity="0.2"
        linesColor="#ad402d"
        :particlesNumber="40"
        shapeType="circle"
        :particleSize="100"
        :linesWidth="2"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="1"
        :hoverEffect="false"
        hoverMode="grab"
        :clickEffect="false"
        clickMode="push"
        class="background"
      ></vue-particles>
      
        <collapsible :items = "collapsibleItems"></collapsible>                
      

     </div>
    
</template>


<script>

import collapsible from '../components/collapsible.vue';

export default {
  name: 'App',
  components: {
    collapsible
  },
  data(){
   return {
     collapsibleItems: [
       {
       header: 'Research',
       body: '<ul class="options"><li><a class="item" href="/philosophy">Philosophy</a></li><li><a href="/physics">Physics</a></li><li><a class="item" href="/mathematics">Mathematics</a></li><li><a class="item" href="/aerospace">Aerospace</a></li></ul>',
       desc: '<p>Research areas of mine. Browse the research timeline of each area</p><p>and find links to my papers and works.</p>'
       },
       {
       header: 'Open projects',
       body: '<ul class="options"><li><a class="item" href="https://astrasolaris.sdescobedo.science/" target="_blank">Astra Solaris</a></li><li><a href="/underconstruction">Physics world</a></li><li><a class="item" href="https://github.com/theopensourcebook">The Open Source Book</a></li><li><a class="item" href="https://github.com/SDEscobedo">More on GitHub <i class="fa fa-github"></i></a></li></ul>',
       desc: '<p>These projects are accessible to anybody with common open source licenses.</p> <p>Explore, use the code or collaborate.</p>'
       },
       {
       header: 'Academic networks',
       body: '<ul class="options"><li><a href="https://philpeople.org/profiles/salvador-daniel-escobedo-casillas/news" target="_blank">Philpeople</a></li><li><a class="item" href="https://www.researchgate.net/profile/Salvador-Escobedo" target="_blank">Research Gate</a></li><li><a class="item" href="https://independent.academia.edu/SalvadorEscobedo4/" target="_blank">Academia</a> - <a class="item" href="https://salvadorescobedo4.academia.edu/" target="_blank">website</a></li><li><a class="item" href="https://stackexchange.com/users/16608216/sdescobedo?tab=accounts" target="_blank">Stack Exchange</a></li></ul>',
       desc: 'Questions, answers and publications posted on academic networks.'
       },
       {
       header: 'Dissemination',
       body: '<ul class="options"><li><a href="https://www.youtube.com/c/4-science" target="_blank">4-Science</a></li><li><a href="/philosophans" target="_self">Philosophans</a></li><li><a href="https://www.blogger.com/profile/10786900451339273001" target="_blank">Blogger</a></li></ul>',
       desc: '<p>Works for dissemination of engineering, science and philosophy.</p> <p>Enjoy videos, conferences and tutorials (in Spanish).</p>'
       },
       {
       header: 'Environments',
       body: '<ul class="options"><li><a href="https://webworks3d.sdescobedo.science/">Web Works 3d</a></li><li><a href="https://gpt.sdescobedo.science/">GPT-3 Experiments</a></li><li><a href="https://innerworld.sdescobedo.science">InnerWorld</a></li></ul>',
       desc: '<p>Enter other pages and virtual worlds. This section contains</p> <p>web experiments, art galleries and other staff.<p>'
       }
       ]
   }
 },
}
</script>

<style scoped>

.body {
  background-color: "#000000";
  font-family: 'PT Mono', monospace;
}

.background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  height: 99%;
}

</style>




// WEBPACK FOOTER //
// src/views/Home.vue